import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActiveSign, AddNewCallDiv, AgentName, Avatar, AvatarDiv, CallBtn, CancelCall, HeadProfileBar, MergeCall, Sign, TransferCall } from '../styles/dialpadstyle';

export class AddNewCallTheme extends Component {
  render() {
    const { userImg, agentName, number, onClickBtnTransfer, btnTransfer, onClickBtnMerge, btnMerge, onClickBtnCancel, btnCancel, textTransfer, textMerge, textCancel } = this.props;
    return (
      <AddNewCallDiv>
        <HeadProfileBar>
          <AvatarDiv>
            <img src={userImg} />
            <ActiveSign><Sign className="active" /></ActiveSign>
          </AvatarDiv>
          <h4>{agentName}</h4>
          <span className='number'>{number}</span>
        </HeadProfileBar>
        <CallBtn>
          <TransferCall>
            <i style={{cursor:  "pointer"}} onClick={()=>{
              onClickBtnTransfer();
            }}>
              <img src={btnTransfer} />
            </i>
            <span>{textTransfer}</span>
          </TransferCall>
          <MergeCall>
            <i style={{cursor:  "pointer"}} onClick={()=>{
              onClickBtnMerge();
            }}>
              <img src={btnMerge} />
            </i>
            <span>{textMerge}</span>
          </MergeCall>
          <CancelCall>
            <i style={{cursor:  "pointer"}} onClick={()=>{
              onClickBtnCancel();
            }}>
              <img src={btnCancel} />
            </i>
            <span>{textCancel}</span>
          </CancelCall>
        </CallBtn>
      </AddNewCallDiv>
    )
  }
}

AddNewCallTheme.propTypes = {
};

AddNewCallTheme.contextTypes = {
  __: PropTypes.func
};

export default AddNewCallTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/AddNewCallTheme.js